import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { RootTabs } from '../../constants/rootTabs';
import { useIsExtraModule } from '../../hooks/useIsExtraModule';
import { Tab } from 'src/shared/components/tab';
import { Routes } from 'src/shared/constants/routes';
export default function Tabs() {
    const location = useLocation();
    const isExtraModule = useIsExtraModule();
    const { t } = useTranslation();
    const tabs = [
        {
            label: t('content_list.tabs.main'),
            name: RootTabs.Main,
            to: { pathname: Routes.ListModules, search: 'extra=false' },
            active: location.pathname.startsWith(Routes.ListModules) && !isExtraModule
        },
        {
            label: t('content_list.tabs.extra'),
            name: RootTabs.Extra,
            to: { pathname: Routes.ListModules, search: 'extra=true' },
            active: location.pathname.startsWith(Routes.ListModules) && isExtraModule
        },
        {
            label: t('content_list.tabs.tracks'),
            to: Routes.Tracks,
            name: RootTabs.Tracks,
            active: location.pathname.startsWith(Routes.Tracks)
        }
    ];
    return (_jsx("div", { className: "flex gap-4", children: tabs.map((tab) => (_jsx(NavLink, { to: tab.to, state: { arrivedFrom: window.location.href }, className: clsx({ 'pointer-events-none': tab.active }), children: _jsx(Tab, { active: tab.active, children: tab.label }) }, tab.name))) }));
}
